function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 8.013a.75.75 0 011.5 0v3.613a.2.2 0 00.094.17l3.232 2.023a.811.811 0 01.26 1.115.748.748 0 01-1.032.24l-3.866-2.41a.4.4 0 01-.188-.34v-4.41zM4 9.214h4.4a1 1 0 110 2H3a1 1 0 01-1-1V4.881a1 1 0 012 0v4.333zm.317 5.78a1 1 0 111.884-.671c1.049 2.94 3.946 4.845 7.106 4.666 3.16-.18 5.815-2.399 6.515-5.438.7-3.036-.719-6.165-3.484-7.675a7.186 7.186 0 00-8.482 1.196L3.68 10.947a1 1 0 01-1.36-1.466l4.154-3.855c2.868-2.826 7.279-3.44 10.823-1.505 3.55 1.939 5.376 5.966 4.473 9.879-.9 3.91-4.306 6.756-8.35 6.985-4.043.23-7.755-2.21-9.104-5.99z"
});

var SvgHistory = function SvgHistory(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/history.5f125eb2.svg";
export { SvgHistory as ReactComponent };